<template>
  <div>
    <Breadcrumb></Breadcrumb>
    <div class="common-limit line-height-40">
      <div class="form-body">
        <el-form ref="form" :model="queryParams" label-width="80px">
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="商家账号：" prop="pOperNo">
                <el-select v-if="role != 'agent'" 
                  clearable
                  size="small"
                  v-model="queryParams.pOperNo"
                  filterable
                >
                  <template v-for="(value, key) in userList">
                    <el-option
                      :key="value.userName"
                      :label="
                        `${value.userName}${
                          value.nickName ? '(' + value.nickName + ')  ' : ''
                        }`
                      "
                      :value="value.userName"
                    ></el-option>
                  </template>
                </el-select>
                <el-input v-else size="small" v-model="queryParams.pOperNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="充值方式：" prop="rechargeMode">
                <el-select
                  clearable
                  size="small"
                  v-model="queryParams.rechargeMode"
                >
                  <template v-for="(value, key) in dictData['recharge_mode']">
                    <el-option
                      :key="value.value"
                      :label="value.label"
                      :value="value.value"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="充值状态：" prop="checkStatus">
                <el-select
                  clearable
                  size="small"
                  v-model="queryParams.checkStatus"
                >
                  <template v-for="(value, key) in dictData['check_status']">
                    <el-option
                      :key="value.value"
                      :label="value.label"
                      :value="value.value"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="充值时间：" prop="time">
                <el-date-picker
                  size="small"
                  v-model="queryParams.time"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="16" class="btn-bar-right">
              <el-button type="primary" size="small" @click="loadData"
                >搜索</el-button
              >
              <el-button size="small" @click="resetForm">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="form-body">
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
        :layout="'slot, total, sizes, prev, pager, next, jumper'"
      >
      </pagination>
      <el-table :data="tableData">
        <el-table-column label="商家账号" prop="pOperNo"></el-table-column>
        <el-table-column label="充值人员" prop="operNo">
          <template slot-scope="scope">
            <span>
              {{
                scope.row.nickName ? scope.row.nickName : scope.row.operNo
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column label="充值时间" prop="createTime" width="180">
        </el-table-column>
        <el-table-column label="充值方式" prop="rechargeMode">
          <template slot-scope="scope">
            <span>{{ dictMap["recharge_mode"][scope.row.rechargeMode] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="充值金额" prop="amount"></el-table-column>
        <el-table-column label="充值截图" prop="picUrl">
          <template slot-scope="scope">
            <el-col style="width: 300px">
              <el-popover
                placement="right"
                :width="scope.row.picWidth"
                trigger="hover"
                :close-delay="closeDelay"
              >
                <img
                  class="img-big"
                  width="300px"
                  height="300px"
                  :src="scope.row.picUrl ? scope.row.picUrl : noImage"
                />
                <img
                  slot="reference"
                  class="img-big"
                  width="100px"
                  height="100px"
                  :src="scope.row.picUrl ? scope.row.picUrl : noImage"
                />
              </el-popover>
            </el-col>
          </template>
        </el-table-column>
        <el-table-column label="充值状态" prop="checkStatus">
          <template slot-scope="scope">
            <span>{{ dictMap["check_status"][scope.row.checkStatus] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="审核人" prop="auditor"></el-table-column>
        <el-table-column
          label="审核时间"
          prop="auditTime"
          width="180"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="审核意见"
          prop="auditOpinion"
        ></el-table-column>
        <el-table-column v-if="role != 'agent'" width="80px" label="操作">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.checkStatus === '01'"
              size="small"
              type="text"
              @click="handleOpenAudit(scope.row)"
              >审核
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
      />
    </div>

    <el-dialog
      :close-on-click-modal="false"
      title="充值审核"
      :visible.sync="dialogVisible"
      destroy-on-close
    >
      <div>
        <el-form
          ref="detailForm"
          :rules="detailFormRules"
          :model="detailForm"
          label-width="140px"
        >
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="商家账号：">
                {{ detailForm.pOperNo }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="充值方式：">
                {{
                  dictMap["recharge_mode"][detailForm.rechargeMode]
                }}</el-form-item
              >
            </el-col>
            <el-col :span="24">
              <el-form-item label="充值金额：">
                {{ detailForm.amount }} 元
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="审核结果：" prop="checkStatus">
                <el-radio-group v-model="detailForm.checkStatus">
                  <el-radio :label="'02'">通过</el-radio>
                  <el-radio :label="'03'">不通过</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="审核意见：">
                <el-input
                  type="textarea"
                  v-model="detailForm.auditOpinion"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" @click="handleAudit"
          >保 存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumb from "@/components/common/Breadcrumb"
import {
  listRecharge,
  updateRecharge,
  listInvite,
} from "@/api/business/fundManage"
import noImage from "@/assets/images/no_image.png"
import { listUser } from "@/api/business/merchantManage"

export default {
  components: { Breadcrumb },
  data() {
    return {
      queryParams: {
        pOperNo: undefined,
        rechargeMode: undefined,
        checkStatus: undefined,
        beginTime: undefined,
        endTime: undefined,
        time: [],
        pageSize: 30,
        pageNum: 1,
      },
      total: 0,
      loading: false,
      noImage: noImage,
      tableData: [],
      closeDelay: 0,
      currentRow: {},
      auditBtnShow: false,
      detailForm: {},
      dialogVisible: false,
      detailFormRules: {
        checkStatus: [
          { required: true, message: "请选择审核结果！", trigger: "blur" },
        ],
      },
      userList: [],
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap", "nginx"]),
    role() {
      return this.$store.state.user.roles[0]
    },
  },
  mounted() {
    this.loadData()
    this.getUserList()
  },
  methods: {
    async getUserList() {
      let result = await listUser({
        pageNum: 1,
        pageSize: 100000,
        userType: "01",
      })
      this.userList = result.rows
    },
    /* 获取列表数据 */
    loadData() {
      let _self = this
      this.startLoading()
      _self.queryParams.beginTime = _self.queryParams.time[0]
      _self.queryParams.endTime = _self.queryParams.time[1]
      let params = Object.assign({}, _self.queryParams)
      delete params["time"]
      let loadMethod = listRecharge
      if (this.role == "agent") {
        loadMethod = listInvite
      }
      loadMethod(params)
        .then((res) => {
          _self.total = res.total
          _self.tableData = res.rows
          this.endLoading()
        })
        .catch((err) => {
          console.error(err)
          this.endLoading()
        })
    },
    resetForm() {
      this.$refs["form"].resetFields()
    },
    handleCurrentChange(val) {
      this.currentRow = val
      if (this.currentRow && this.currentRow.checkStatus === "01") {
        this.auditBtnShow = true
      } else {
        this.auditBtnShow = false
      }
    },
    handleOpenAudit(row) {
      this.detailForm = Object.assign({}, row)
      this.detailForm.checkStatus = "02"
      this.dialogVisible = true
    },
    handleAudit() {
      let _self = this
      this.$refs["detailForm"].validate((valid) => {
        if (valid) {
          if (
            _self.detailForm.checkStatus == "03" &&
            (_self.detailForm.auditOpinion == null ||
              _self.detailForm.auditOpinion.trim() == "")
          ) {
            _self.$message.error("请填写审核意见")
            return
          }
          updateRecharge(_self.detailForm).then((response) => {
            if (response.code == "200") {
              _self.$message.success("审核成功！")
              _self.dialogVisible = false
              _self.loadData()
            } else {
              _self.$message.error("审核失败！")
            }
          })
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-bar-right {
  text-align: right;
}
</style>
